//Интерфейс для работы с корзиной

//обновления блока с информацией о корзине
var updateCartBlock = function () {
    var totalCount = 0,
        $cart = $(".js-basket");

    for (var i = 0; i < Cart.items.length; i++) {
        totalCount += parseInt(Cart.items[i].qty, 10);
    }

    if (totalCount > 0) {
        $cart.find('.btn__counter').removeClass('h-invisible').text(totalCount > 99 ? 99 : totalCount);
    } else {
        $cart.find('.btn__counter').addClass('h-invisible').text(0);
    }
};

//обновлялка инфы на странице корзины
var updateCartPage = function () {
    var totalPrice = 0;

    for (var item_id in Cart.items) {
        totalPrice += Cart.items[item_id].price * Cart.items[item_id].qty;
    }

    if (window.hasOwnProperty('delivery_limit')) {
        if (totalPrice > window.delivery_limit) {
            $('.js-hide-delivery').css({opacity: 0});
        } else {
            $('.js-hide-delivery').css({opacity: 1});
        }
    }

    $(".js-cart-sum").text(Meta.beautyPrice(totalPrice) + ' руб.');
};


$(function () {
    //кнопка купить
    $('.js-add-to-cart').on("click", function (e) {

        var $this = $(this),
            id = parseInt($this.attr('data-id'), 10),
            item = Cart.getItem(id);

        if (item) {
            Cart.putItem({
                id: id,
                qty: item.qty + 1
            }, true, function () {
                updateCartBlock();
                $this.siblings('.atb__link').find('.atb__counter').text(item.qty > 99 ? 99 : item.qty);
                $this.parent().addClass("atb--active");
            });
        } else {
            Cart.putItem({
                id: id,
                qty: 1
            }, false, function () {
                updateCartBlock();
                $this.siblings('.atb__link').find('.atb__counter').text(1);
                $this.parent().addClass("atb--active");
            });
        }

        e.preventDefault();

        if (window.hasOwnProperty('ym')) {
            window.ym(52695778, 'reachGoal', 'v_korziny');
        }
    });

    // ************ страница корзины ***************
    $('.js-cart-item').map(function () {
        var $product = $(this),
            id = parseInt($product.attr('data-id'), 10),
            price = parseInt($product.attr('data-price'), 10);

        $product.find('.js-cart-remove').on('click', function (e) {
            if (Cart.items.length > 1) {
                $product.slideUp(500, function () {
                    $(this).remove();
                });
            } else {
                window.location.href = $(".js-basket").attr('data-empty');
            }

            Cart.removeItem({id: id}, function () {
                updateCartBlock();
                updateCartPage();
            });

            e.preventDefault();
        });

        $product.find('.js-cart-plus').on('click', function (e) {
            var inputVal = ($product.find(".js-cart-count").val().replace(/\,/, '.') * 1),
                newValue;

            if (!inputVal) {
                newValue = 1;
            } else {
                newValue = (inputVal + 1).toFixed(1) * 1;
            }

            if (newValue > Cart.maxItemQty) {
                newValue = Cart.maxItemQty;
            }

            $product.find(".js-cart-count").val(newValue);
            $product.find(".js-cart-item-sum").text(Meta.beautyPrice(price * newValue) + ' руб.');

            Cart.putItem({
                id: id,
                qty: newValue,
                price: price
            }, true);

            updateCartBlock();
            updateCartPage();

            e.preventDefault();
        });

        $product.find('.js-cart-minus').on('click', function (e) {
            var inputVal = ($product.find(".js-cart-count").val().replace(/\,/, '.') * 1),
                newValue;

            if (!inputVal || inputVal == 1) {
                newValue = 1;
            } else {
                newValue = (inputVal - 1).toFixed(1) * 1;
            }

            $product.find(".js-cart-count").val(newValue);
            $product.find(".js-cart-item-sum").text(Meta.beautyPrice(price * newValue) + ' руб.');

            Cart.putItem({
                id: id,
                qty: newValue,
                price: price
            }, true);

            updateCartBlock();
            updateCartPage();

            e.preventDefault();
        });

        $product.find('.js-cart-count').on('input', function (e) {
            var newQty = parseInt($(this).val(), 10);

            if (!newQty || (newQty < 0)) {
                newQty = 1;
            }

            if (newQty > Cart.maxItemQty) {
                newQty = Cart.maxItemQty;
            }

            $(this).val(newQty);

            $product.find(".js-cart-item-sum").text(Meta.beautyPrice(price * newQty) + ' руб.');

            Cart.putItem({
                id: id,
                qty: newQty,
                price: price
            }, true);

            updateCartBlock();
            updateCartPage();

            e.preventDefault();
        });

    });

    Cart.onInitCallback = function () {
        updateCartBlock();
        updateCartPage();
    };
});

